import { dev, nodeEnvironment } from '../utils/environment-utils'
import { env } from '../env'
import { isServer } from '../utils/platform-utils'

interface AppConfig {
    basePath: string
    baseUrl: string
    dev: boolean
    environment: 'development' | 'staging' | 'production'
    firebaseApiKey?: string
    firebaseAppId?: string
    firebaseMessagingSenderId?: string
    firebaseProjectId: string
    firebaseAuthDomain: string
    firebaseStorageBucket: string
    gtmContainerId: string
    nodeEnvironment: 'development' | 'production'
    sentryDSN: string
    googleSiteVerification: string
    assetPrefix: string
    gMapKey: string
    googleEmbeddedMapsKey: string
    htgPublicUrl: string
    gygPartnerId?: string
}

const config: AppConfig = {
    basePath: env.NEXT_PUBLIC_BASE_PATH,
    // Server-only + runtime (per-deploy): never bake it. The client uses location.origin.
    baseUrl: isServer ? env.BASE_URL : '',
    dev,
    environment: env.NEXT_PUBLIC_ENV,
    firebaseApiKey: env.NEXT_PUBLIC_FIREBASE_API_KEY,
    firebaseAppId: env.NEXT_PUBLIC_FIREBASE_APP_ID,
    firebaseMessagingSenderId: env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    firebaseProjectId: env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    firebaseAuthDomain: env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    firebaseStorageBucket: env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
    gtmContainerId: env.NEXT_PUBLIC_GTM_CONTAINER_ID,
    nodeEnvironment,
    sentryDSN: env.NEXT_PUBLIC_SENTRY_DSN ?? '',
    googleSiteVerification: env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    assetPrefix: env.NEXT_PUBLIC_ASSET_PREFIX,
    gMapKey: env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
    googleEmbeddedMapsKey: env.NEXT_PUBLIC_GOOGLE_EMBEDDED_MAPS_KEY,
    htgPublicUrl: env.NEXT_PUBLIC_HTG_PUBLIC_URL,
    gygPartnerId: env.NEXT_PUBLIC_GYG_PARTNER_ID,
}

export default config
